import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MixedLoyaltyListComponent } from './mixed-loyalty-list.component';

import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { LoadingModule } from '@fgb/portal-component-library/src/lib/shared/loading';
import { MixedLoyaltyItemModule } from './mixed-loyalty-item/mixed-loyalty-item.module';
import { DataSourceDirective, DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';
import { InlineSVGModule } from 'ng-inline-svg-2';

@NgModule({
  declarations: [MixedLoyaltyListComponent],
  imports: [
    CommonModule,
    DataSourceDirective,
    NgbPaginationModule,
    MixedLoyaltyItemModule,
    FGBSharedModule,
    LoadingModule,
    InlineSVGModule,
    DirectivesModule,
  ],
  exports: [MixedLoyaltyListComponent],
})
export class MixedLoyaltyListModule {}
